import { createSlice } from '@reduxjs/toolkit';
import { RootState } from "../app/store";

export interface ServiceProviderFeedbackState {
    data: [] | null | any;
    averageRating :number | null;
    totalPage: number | null;
    currentPage: number | null;
    totalRecords: number | null;
}
const initialState: ServiceProviderFeedbackState = {
    data: null,
    averageRating:null,
    totalPage: null,
    currentPage: null,
    totalRecords: null,
};
export const serviceProviderFeedbackSlice = createSlice({
    name: 'serviceProvider',
    initialState,
    reducers: {
        setServiceProviderFeedback: (state, action) => {
            state.data = action.payload?.data;
            state.averageRating=action.payload?.AverageRating;
            state.totalPage = action.payload?.totalPage;
            state.currentPage = action.payload?.currentPage;
            state.totalRecords = action.payload?.totalRecords;
        },
        addNewServiceProviderFeedback: (state: any, action) => {
            state.data = [action.payload.data, ...state.data];
        },
        reset: (state) => {
            state = initialState;
        },
    },
});
export const { setServiceProviderFeedback, addNewServiceProviderFeedback, reset } = serviceProviderFeedbackSlice.actions;

export const  getServiceProviderFeedbackData = (state:RootState) => state.serviceProviderFeedback.data;
export const  getServiceProviderFeedbackAverageRating = (state:RootState) => state.serviceProviderFeedback.averageRating;


export default serviceProviderFeedbackSlice.reducer;